import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import SEOHead, { reviewAggregateSchema } from "@/components/SEOHead";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  const reviewS = reviewAggregateSchema(items);

  return (
    <div data-testid="testimonials-page">
      <SEOHead
        title="Patient Testimonials | Dr. Ashutosh Mishra — Varanasi"
        description="Read real patient reviews and outcomes from people treated by Dr. Ashutosh Mishra at the Diabetes & Endocrinology Clinic in Kabir Nagar, Varanasi."
        path="/patient-testimonials"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Patient Testimonials", url: "/patient-testimonials" },
        ]}
        schemas={reviewS ? [{ id: "ld-reviews", data: reviewS }] : []}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <nav className="text-xs text-slate-500 mb-3 text-left">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Patient Testimonials</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Patient reviews</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-3">What Our Patients Say</h1>
          <p className="text-slate-600 text-lg mt-4 max-w-2xl mx-auto">Real stories from real Varanasi patients treated by Dr. Ashutosh Mishra.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t) => (
            <div key={t.id} data-testid={`review-${t.id}`} className="bg-white border border-slate-100 rounded-3xl p-7 shadow-sm hover:shadow-md transition">
              <div className="flex gap-0.5 text-amber-500 mb-3">
                {Array.from({ length: t.rating || 5 }).map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-500" />)}
              </div>
              <p className="text-slate-700 leading-relaxed">"{t.quote}"</p>
              <div className="mt-5 pt-5 border-t border-slate-100">
                <div className="font-medium text-slate-900">{t.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{t.condition} • {t.location}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
